export default __webpack_public_path__ + "static/media/Wall Reader Design.9ee2084f.jpg";